import styled from 'styled-components';
import { space } from 'styled-system';
import { themeGet } from '@magalu/stereo-ui-styles';
import Box from '../../../atoms/Box';
import { PriceDefault } from '../price.styles';
export const PriceMiniatureLabel = styled.p`
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  line-height: ${props => themeGet('lineHeights.standard')(props)}px;
`;
export const PriceMiniature = styled(PriceDefault)`
  text-align: center;
  line-height: ${props => themeGet('lineHeights.small')(props)};
  letter-spacing: normal;
  font-size: ${props => themeGet('fontSizes.2')(props)}px;
  p {
    padding: 3px 0px 0px;
  }
`;
export const ProductMiniatureContent = styled(Box).attrs(_ref => {
  let style = Object.assign({}, _ref);
  return Object.assign({
    mt: '8px'
  }, style);
})`
  line-height: 6px;
  ${space}
`;
export const EmptyPrice = styled.div``;